import React from 'react';

const WhyAutzu = () => (
  <div className="toronto-why-autzu">
    <div className="toronto-why-autzu__container">
      <h2>Why Autzu?</h2>
      <div className="toronto-why-autzu__content">
        {content.map(column => (
          <div className="toronto-why-autzu__column">
            <h3> {column.title}</h3>
            <p> {column.text} </p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const content = [
  {
    title: 'Flexibility',
    text:
      'Book an Autzu vehicle for 4, 8, or 12 hours any day of the week. Enjoy the freedom to earn with no financial commitments.',
  },
  {
    title: 'No upfront costs',
    text:
      'Hourly rental fees are automatically deducted from your Uber earnings. What about financing or leasing fees, you ask? That’s on us.',
  },
  {
    title: 'All inclusive',
    text:
      'Hourly rental fees include full collision and liability insurance, complete maintenance, roadside assistance and free parking for your personal vehicle.',
  },
];
export default WhyAutzu;



// WEBPACK FOOTER //
// ./src/components/Static/UberToronto/WhyAutzu.js